const anchorLinks = document.querySelectorAll(".anchor-link");
const tabsItems = document.querySelectorAll(".tabs-title");
const tabsPanels = document.querySelectorAll(".tabs-panel");
const tabBlock = document.querySelector(".tab-block");

anchorLinks.forEach((link) => {
  link.addEventListener("click", (event) => {
    event.preventDefault(); // Prevent default anchor behavior

    const linkToJump = link.getAttribute("data-link-jump-to");

    // Remove is-active class from all tabs items
    tabsItems.forEach((item) => {
      item.classList.remove("is-active");
      item.setAttribute("aria-selected", "false"); // Set aria-selected to "false" for all tab items
      // Set aria-selected to "false" for all nested <a> tags
      const nestedAnchorTag = item.querySelector("a");
      if (nestedAnchorTag) {
        nestedAnchorTag.setAttribute("aria-selected", "false");
      }
    });

    // Add is-active class and set aria-selected to "true" to the clicked tab item
    tabsItems.forEach((item) => {
      if (item.classList.contains(linkToJump)) {
        item.classList.add("is-active");
        item.setAttribute("aria-selected", "true");
        // Set aria-selected to "true" for the nested <a> tag
        const nestedAnchorTag = item.querySelector("a");
        if (nestedAnchorTag) {
          nestedAnchorTag.setAttribute("aria-selected", "true");
        }
      }
    });

    // Remove is-active class from all tabs panels
    tabsPanels.forEach((panel) => {
      panel.classList.remove("is-active");
    });

    // Add is-active class to the tab panel whose class matches linkToJump
    tabsPanels.forEach((panel) => {
      if (panel.classList.contains(linkToJump)) {
        panel.classList.add("is-active");
      }
    });

    // Smooth scroll down to the tab-block
    tabBlock.scrollIntoView({ behavior: "smooth" });
  });
});
